import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from '../styles';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import EditIcon from '@material-ui/icons/Edit';
import { DateTime } from 'luxon';
import { CommentsData } from '../interfaces';

const CommentsPopup = ({ data, open, onClose, onSubmit }: any) => {
  const classes = useStyles();
  const [editingCommentId, setEditingCommentId] = useState(null);
  // const [originalComment, setOriginalComment] = useState<string>('');
  const [formData, setFormData] = useState<CommentsData>({
    ticket_id: data?.id,
    comment_text: '',
  });

  const handleEditClick = (comment: any) => {
    setEditingCommentId(comment?.comment_id);
    // setOriginalComment(comment?.comment_text);
    setFormData({
      ...formData,
      comment_text: comment?.comment_text,
      comment_id: comment?.comment_id,
    });
  };

  const handleCancelEdit = () => {
    setEditingCommentId(null);
    setFormData({
      ...formData,
      comment_text: '',
      comment_id: undefined,
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit('comment', formData);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.popupTitle}>
        <DialogTitle>
          <span>Your comments</span>
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        {data?.comments ? (
          data?.comments?.map((comment: any) => (
            <div className={`${classes.minWidth250} ${classes.commentBlock}`}>
              {editingCommentId === comment?.comment_id ? (
                <div className={classes.editCommentBlock}>
                  <TextField
                    variant="outlined"
                    value={formData.comment_text}
                    onChange={handleChange}
                    name="comment_text"
                    fullWidth
                    multiline
                    minRows={2}
                    autoFocus
                  />
                  <div className={classes.editActions}>
                    <IconButton onClick={handleCancelEdit}>
                      <CloseIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        handleSubmit();
                        setEditingCommentId(null);
                      }}
                    >
                      <SendOutlinedIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <>
                  <div>{comment?.comment_text}</div>
                  <div className={classes.individualCommentAction}>
                    <span>
                      {comment?.created_at
                        ? DateTime.fromISO(comment?.created_at).toFormat(
                            'dd MMM yyyy, hh:mm a',
                          )
                        : '-'}
                    </span>
                    <IconButton onClick={() => handleEditClick(comment)}>
                      <EditIcon />
                    </IconButton>
                  </div>
                </>
              )}
            </div>
          ))
        ) : (
          <div className={`${classes.minWidth250} ${classes.commentBlock}`}>
            <Typography>No comments to show.</Typography>
            <div className={classes.individualCommentAction} />
          </div>
        )}
      </DialogContent>
      <DialogActions
        className={`${classes.justifyContentNormal} ${classes.customPadding}`}
      >
        <TextField
          variant="outlined"
          label="New comment"
          onChange={handleChange}
          name="comment_text"
          placeholder="Add new comment"
          fullWidth
          multiline
          minRows={2}
          InputProps={{
            endAdornment: (
              <IconButton onClick={handleSubmit}>
                <SendOutlinedIcon />
              </IconButton>
            ),
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CommentsPopup;
